import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import { setSession } from 'utils/set-session'
import { prefetchPaymentConfig, useCountryCode } from 'querys/payment'
import { prefetchProject, useProject } from 'querys/projects'
import { getProjectService } from 'services/projects'
import { getPaymentCountryService } from 'services/payment'
import {
  getSubscriptionStatus,
} from 'services/subscriptions'
import CheckoutLayout from 'checkout/checkout-layout'
import InternalError from 'errors/internal-error'

function SingleProjectCheckout() {
  const router = useRouter()
  const { data: { title, slug, price, is_free }, isLoading, error } = useProject()
  const { data: { countryCode } } = useCountryCode()
  useEffect(() => {
    if (is_free) {
      router.push('/proyectos/todos')
    }
  }, [])
  if (isLoading) return null

  if (error?.message === 'User Unauthorized') {
    router.push(`/login?next=${router.asPath}`)
    return null
  }
  if (error?.message === 'Internal Error') return <InternalError />

  const defaultPrice = countryCode === 'MX' ? { amount: 200, currency_code: 'MXN' } : { amount: 10, currency_code: 'USD' }

  return (
    <CheckoutLayout
      title={title}
      url={`https://leonidasesteban.com/comprar/proyectos/${slug}`}
      price={price || defaultPrice}
      type="singleProject"
    />
  )
}

export const getServerSideProps = async ({
  req, res, query,
}) => {
  const queryClient = new QueryClient()
  const { token } = setSession(req, queryClient)
  const { project } = query
  if (token) {
    try {
      const { progress_status } = getProjectService({ project, token, countryCode: 'MX' })
      const { is_active } = getSubscriptionStatus({ token })
      if (progress_status?.uuid || is_active) {
        res.writeHead(302, { Location: '/proyectos/todos' })
        res.end()
      }
    } catch ({ message }) {
      if (message === 'User Unauthorized') {
        const { url } = req
        res.setHeader('Set-Cookie', 'user_token=deleted; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT')
        res.setHeader('Set-Cookie', 'user_payload=deleted; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT')
        res.writeHead(302, {
          location: `/login?next=${url}`,
        })
        res.end()
      }
    }
  }

  let country = ''
  const ip = req.headers['x-forwarded-for'] || req.connection.remoteAddress
  const { headers: { host } } = req
  if (host.includes('localhost') || host.includes(':3000')) {
    country = 'CO'
  } else {
    const data = await getPaymentCountryService({ ip })
    queryClient.setQueryData('GET_COUNTRY_CODE', data)
    country = data.countryCode
  }
  await prefetchPaymentConfig(queryClient, country)
  await prefetchProject(queryClient, project, token, country)

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  }
}


export default SingleProjectCheckout
